import { NavigationButtonTypes } from "../types/button";
import ICONS from "./icons";

import AnthonyImage from "../assets/images/anthony.webp";
import MikeImage from "../assets/images/mike.webp";
import JovanaImage from "../assets/images/jovana.webp";
import BrankoImage from "../assets/images/branko.webp";
import PhilipImage from "../assets/images/philip.webp";
import FlorianImage from "../assets/images/florian.webp";
import PavleImage from "../assets/images/pavle.webp";
import VukasinImage from "../assets/images/vukasin.webp";

import { BoxButtonTypes } from "../types/button";
import { MenuItemTypes } from "../types/layout";

import MENU_PATHS from "./menu";

import PartnersImage from "../assets/images/partners.png";

export const SCREEN_WIDTHS = {
  EXTRA_EXTRA_LARGE: 1300,
  EXTRA_LARGE: 1200,
  LARGE: 992,
  MEDIUM: 768,
  SMALLER_MEDIUM: 576,
  SMALL: 480,
};

export const socialButtons: NavigationButtonTypes[] = [
  {
    id: 1,
    path: "https://www.linkedin.com/company/skill-n-depth",
    iconName: ICONS.LINKEDIN,
  },
  {
    id: 2,
    path: "https://www.facebook.com/profile.php?id=61568756263256",
    iconName: ICONS.FACEBOOK,
  },
  {
    id: 3,
    path: "https://www.instagram.com/skillndepthapp",
    iconName: ICONS.INSTAGRAM,
  },
];

export const menuItems: MenuItemTypes[] = [
  { id: 1, name: "Home", path: MENU_PATHS.HOMEPAGE },
  {
    id: 2,
    name: "About",
    path: "",
    dropdown: [
      { id: 1, name: "About us", path: MENU_PATHS.ABOUT_US },
      { id: 2, name: "Team", path: MENU_PATHS.TEAM },
    ],
  },
  { id: 3, name: "News", path: MENU_PATHS.NEWS },
  {
    id: 5,
    name: "Services",
    path: "",
    rounded: true,
    dropdown: [
      {
        id: 1,
        name: "Partners",
        path: MENU_PATHS.PARTNERS,
      },
      {
        id: 2,
        name: "For dive team members",
        path: MENU_PATHS.DIVE_TEAM_MEMBERS,
      },
      {
        id: 3,
        name: "For companies",
        path: MENU_PATHS.DIVING_ORGANIZATIONS,
      },
      {
        id: 4,
        name: "For trade organizations",
        path: MENU_PATHS.ADVERTISING_AND_MARKETING,
      },
      {
        id: 5,
        name: "For dive schools",
        path: MENU_PATHS.DIVE_SCHOOLS,
      },
      {
        id: 6,
        name: "For client organizations",
        path: MENU_PATHS.CLIENT_ORGANIZATIONS,
      },
    ],
  },
  { id: 6, name: "Contact us", path: MENU_PATHS.CONTACT },
];

export const BOX_BUTTONS_ABOUT_US: BoxButtonTypes[] = [
  {
    id: 1,
    icon: ICONS.CLASS,
    title: "Our Mission",
    description:
      "Our mission is to deliver a secure, blockchain-verified platform that enables the global occupational diving industry to digitally log, verify, and showcase skills and experience. Through innovative technology, we aim to bridge the gap between diving professionals and industry opportunities, ensuring that verified skills drive success in high-risk environments.",
  },
  {
    id: 2,
    icon: ICONS.LIGHT_BUBLE,
    title: "Our Vision",
    description:
      "We strive to create a globally trusted, blockchain-verified platform that empowers divers and organizations to confidently showcase, verify, and manage skills and experience. We aim to enhance safety, transparency, and efficiency in high-risk sectors by digitizing the validation process, reducing reliance on outdated methods, and promoting sustainability. Skill N Depth envisions a future where every diving professional's expertise is recognized, verified, and connected seamlessly to opportunities worldwide.",
  },
];

export const teamMembers = [
  {
    id: 1,
    image: AnthonyImage,
    name: "Anthony Greenwood",
    position: "CEO",
    description:
      "Respected commercial diving technical specialist, serving over three decades in industrial diving, marine construction operations, and oil & gas businesses. Leader of a Global Centre of Diving Expertise spanning 23 countries for ExxonMobil; influenced change in the global regulatory regime by updating commercial diving laws in maritime countries diving from registered ships, via International Maritime Organization (IMO), Keynote Speaker on diving safety/regulation and an influential member of global industry associations. ",
    linkedin:
      "https://www.linkedin.com/in/anthony-greenwood-commercial-diving-specialist?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BtT3vNz%2BgSK6KzZV0otTQZA%3D%3D",
  },
  {
    id: 2,
    image: MikeImage,
    name: "Mike Jessop",
    position: "Industry relations",
    description:
      "Business owner, Naval Mechanical Engineer with a Subsea Engineering background. Founding member of 2 Multi-National Diving Companies with experience in the strategic management of a company both from a start-up to running a corporate regional division in a multinational oil and gas company. ",
    linkedin:
      "https://www.linkedin.com/in/mike-jessop?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BfQrjD0jVSm65K1Aiqa2Hng%3D%3D",
  },
  {
    id: 3,
    image: JovanaImage,
    name: "Jovana Sokolović",
    position: "Operations",
    description:
      "Brand design and marketing specialist across a variety of industries - including oil & gas, technology, diving equipment manufacturing, healthcare, retail, consumer products and professional services. Areas of expertise: brand design and strategy, digital media strategy & PR. ",
    linkedin:
      "https://www.linkedin.com/in/jovanasokolovic?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BnNM5pWCCRuSUZf7P5jingg%3D%3D",
  },
  {
    id: 4,
    image: BrankoImage,
    name: "Branko Mitrović",
    position: "CTO",
    description:
      "Entrepreneur and CEO with a proven track record in IT ecosystems. As a founder of ewasoft, he has been proactively participating in all aspects of business development, management, system design, harnessing cutting edge technologies, product and project management, and IT solutions development. Branko has vast experience in leading teams and covering key aspects in the design and implementation of complex technology solutions (ERP, CRM, eCommerce, other business platforms) in different contexts, IT sales, negotiations, and entrepreneurship. ",
    linkedin: "https://www.linkedin.com/in/branko-mitrovi%C4%87-ewasoft/",
  },
  {
    id: 5,
    image: PhilipImage,
    name: "Philipp Jann",
    position: "Product and design",
    description:
      "CEO with a history in the computer software industry. Skilled in client counseling, business development, entrepreneurship, strategic planning, and marketing strategy. Strong business development professional with a Master of Arts focused on Management. ",
    linkedin:
      "https://www.linkedin.com/in/philippjann?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bj4QrnSqcShmF3BgsV9XEUQ%3D%3D",
  },
  {
    id: 6,
    image: FlorianImage,
    name: "Florian Paschka",
    position: "Customer success",
    description:
      "Entrepreneur with a background in strategy consulting and mergers & acquisitions at KPMG Switzerland. Skilled in developing innovative software solutions, real estate investment, and strategic planning. Holds a Bachelor’s Degree in International Management from National Taiwan University and ZHAW School of Management and Law.",
    linkedin:
      "https://www.linkedin.com/in/florian-paschka-3061425b?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BVIpCsHEIRJO5gJodhoWSBg%3D%3D",
  },
  {
    id: 7,
    image: PavleImage,
    name: "Pavle Lošić",
    position: "Engineering",
    description:
      "Experienced Software Engineer with a demonstrated history of working in the information technology and services industry. Strong engineering professional with a Master of Science - MS focused in Information Technology.",
    linkedin: "https://www.linkedin.com/in/pavle-lo%C5%A1i%C4%87/",
  },
  {
    id: 8,
    image: VukasinImage,
    name: "Vukašin Daskalović",
    position: "Delivery",
    description:
      "Delivery Manager with a proven track record of successfully spearheading B2B and B2C web and mobile development projects across diverse sectors including oil & gas, air navigation, retail, real estate, and food industries. Strong analytical and problem-solving background, excellence in team management and organization.",
    linkedin: "https://www.linkedin.com/in/vukasindaskalovic/",
  },
];

export enum LIST_TYPES {
  ORDERED,
  NUMBER,
}



export const WHY_JOIN: BoxButtonTypes[] = [
  {
    id: 1,
    path: "",
    title: "Influence Development",
    description: "Help shape features tailored to your operational needs.",
  },
  {
    id: 2,
    path: "",
    title: "Early Access",
    description:
      "Get a first look at a platform designed to improve accountability, efficiency, and documentation.",
  },
  {
    id: 3,
    path: "",
    title: "Visibility",
    description:
      "Be recognized as a technology-forward leader committed to safety, standards, and digital evolution.",
  },
  {
    id: 4,
    path: "",
    title: "Training & Support",
    description:
      "Our team works closely with each partner to onboard users and gather feedback in a structured, supported environment.",
  },
];


export const pilotProgramPartnersObject = {
  mainTitle: "Pilot Program Partners",
  subtitle: "Pilot Program Partners",
  description1:
    "At Skill N Depth, our Pilot Program is more than a test phase—it’s a collaborative journey with key industry players to shape the future of workforce management, compliance, and digital operations in commercial diving.",
  description2:
    "We’ve partnered with forward-thinking companies, schools, trade associations, and manufacturers who recognize the value of real-time data, transparent records, and verified competence. These partners are helping us stress-test and refine our platform in live environments, across different regions and operational contexts.",
  image: PartnersImage,
  noButton: true,
};

